<template>
  <div>
    <Header
      :settings="settings"
      :showLoginModal="showLoginModal"
      :showRegistrationModal="showRegistrationModal"
      @openLogModal="openLogModal"
      @openRegModal="openRegModal"
    >
    </Header>
    <div class="p-breadcrumb bg-donate">
      <v-container pa-0>
        <h1>{{ $t('donation.donate') }}</h1>
      </v-container>
    </div>
    <v-container grid-list-md text-xs-center class="donation-content">
      <v-layout>
        <v-flex class="">
          <h2 class="g-title sub-title">{{ $t('donation.header') }}</h2>
          <div>
            <v-btn :key="index" @click="selectPrice(button.price)"
                   class="selectPay" color="indigo" outline
                   v-for="(button, index) in buttons">{{button.name}}
            </v-btn>
          </div>
          <div class="paymentInput">
            <v-subheader class="usd">USD</v-subheader>
            <v-text-field class="paymentArea"
                          type="number"
                          v-model=amount
            ></v-text-field>
          </div>
          <div class="payPal-btn">
            <v-btn
              :href="PayLink"
              class=" g-btn-main-light"
              color="primary" dark round target="_blank">
              {{ $t('donation.donate_now') }}
            </v-btn>
          </div>
          <p class="page-text">
            {{ $t('donation.text_1') }}
          </p>
          <p class="page-text">
            {{ $t('donation.text_2') }}
          </p>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Header from '../components/global/Header.vue'
export default {
  name: 'Donation',
  components: {
    Header
  },
  data: () => ({
    settings: [],
    donationLink: 'https://www.paypal.me/giveram',
    amount: '0.00',
    currency: 'USD',
    buttons: [
      {name: '5 USD', price: '5.00'},
      {name: '10 USD', price: '10.00'},
      {name: '20 USD', price: '20.00'},
      {name: '50 USD', price: '50.00'},
      {name: '100 USD', price: '100.00'}
    ],
    showRegistrationModal: false,
    showLoginModal: false
  }),
  computed: {
    PayLink () {
      if (this.amount !== '0.00') {
        return this.donationLink + '/' + parseFloat(this.amount) + this.currency
      }
      return this.donationLink
    }
  },
  methods: {
    openRegModal () {
      this.showRegistrationModal = !this.showRegistrationModal
    },
    openLogModal () {
      this.showLoginModal = !this.showLoginModal
    },
    selectPrice (amount) {
      this.amount = amount
    }
  }
}
</script>

<style lang="scss" scoped>
  .bg-donate {
    background-image: url("../assets/images/slider/giving.png");
    background-position: center 30%;
  }
  .donation-content {
    padding-top: 100px;
    padding-bottom: 100px;
    @media screen and (max-width: 992px) {
      padding-top: 60px;
      padding-bottom: 60px;
    }
    .sub-title {
      margin: 0 0 40px 0;
      text-align: center;
      text-transform: capitalize;
    }
  }
  .page-text {
    font-size: 14px;
    font-weight: 500;
    color: #6c7781;
  }
  .paymentInput {
    display: flex;
    justify-content: center;
  }
  .paymentArea {
    max-width: 150px;
  }
  .usd {
    padding-top: 16px;
  }
  .payPal-btn {
    margin: 40px auto;
    width: auto;
    a {
      width: auto;
      padding: 0 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/DonationPage.vue